import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FormLayout } from '@/components/common/FormLayout';
import { PageLayout } from '@/components/common/PageLayout';
import { RegisterForm } from '@/components/register/RegisterForm';

export default function RegisterIndex() {
  const { t } = useTranslation();
  // 与 RegisterForm 一致：只有点击「使用其他方式登录」才回到普通标题
  const [showSSOMode, setShowSSOMode] = useState(false);

  const title = showSSOMode ? t('loginForm.ssoLoginTitle') : t('auth.register.title');

  return (
    <PageLayout>
      <FormLayout title={title}>
        <RegisterForm showSSOMode={showSSOMode} onSSOModeChange={setShowSSOMode} />
      </FormLayout>
    </PageLayout>
  );
}
